import { Dispatch, SetStateAction } from "react";
import { Table, Input } from "semantic-ui-react";
import { IValue, IVerticesFiltering } from "../../../../../store/verticesFilteringReducer";

interface IProps {
    selectedVerticesLimits: IVerticesFiltering;
    setSelectedVerticesLimits: Dispatch<SetStateAction<IVerticesFiltering | undefined>>;
    ahc: boolean;
    disabled: boolean;
}

export const VerticesFilteringTable = ({
    selectedVerticesLimits,
    ahc,
    disabled,
    setSelectedVerticesLimits
}: IProps) => {
    const handleMinValueChange = (country: string, minValue: number) => {
        setSelectedVerticesLimits({
            ...selectedVerticesLimits,
            values: {
                ...selectedVerticesLimits.values,
                [country]: {
                    ...selectedVerticesLimits.values[country],
                    minValue: minValue,
                },
            },
        });
    };

    const handleMaxValueChange = (country: string, maxValue: number) => {
        setSelectedVerticesLimits({
            ...selectedVerticesLimits,
            values: {
                ...selectedVerticesLimits.values,
                [country]: {
                    ...selectedVerticesLimits.values[country],
                    maxValue: maxValue,
                },
            },
        });
    };

    const entries = Object.entries(selectedVerticesLimits.values);
    const withAhc: IValue = Object.fromEntries(
        entries.filter(([_, value]) => value.ahc === true)
    );

    const withoutAhc: IValue = Object.fromEntries(
        entries.filter(([_, value]) => value.ahc !== true)
    );

    let tempValues = withoutAhc;
    if (ahc) {

        tempValues = withAhc;
    }

    let selectedVerticesLimitsCopy: IVerticesFiltering = {
        hour: selectedVerticesLimits.hour,
        values: tempValues,
    };

    return (
        <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Vertex Values</Table.HeaderCell>
                    {Object.keys(selectedVerticesLimitsCopy.values).map(x => (
                        <Table.HeaderCell key={x} className="content-cell">
                            {ahc ? x : x.toUpperCase()}
                        </Table.HeaderCell>
                    ))}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell collapsing>Min Value</Table.Cell>
                    {Object.entries(selectedVerticesLimitsCopy.values).map(nps => (
                        <Table.Cell selectable key={nps[0]} className="content-cell">
                            <Input
                                type="number"
                                value={nps[1].minValue}
                                onChange={(e: any) => handleMinValueChange(nps[0], e.target.value)}
                                disabled={disabled}
                            />
                        </Table.Cell>
                    ))}
                </Table.Row>
                <Table.Row>
                    <Table.Cell collapsing>Max Value</Table.Cell>
                    {Object.entries(selectedVerticesLimitsCopy.values).map(nps => (
                        <Table.Cell selectable key={nps[0]} className="content-cell">
                            <Input
                                type="number"
                                value={nps[1].maxValue}
                                onChange={(e: any) => handleMaxValueChange(nps[0], e.target.value)}
                                disabled={disabled}
                            />
                        </Table.Cell>
                    ))}
                </Table.Row>
            </Table.Body>
        </Table>
    );
};
